// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Config from "../../../../../Config.bs.js";
import * as $$String from "../../../../../../node_modules/rescript/lib/es6/string.js";
import * as CityConfig from "../../store/CityConfig.bs.js";

function geoRegionIdToCity(id) {
  if (Config.Env.env === "staging") {
    if (id >= 21) {
      switch (id) {
        case 71 :
            return CityConfig.kolkata;
        case 72 :
            return CityConfig.surat;
        case 73 :
            return CityConfig.lucknow;
        case 74 :
        case 75 :
        case 76 :
        case 77 :
        case 78 :
        case 79 :
            return CityConfig.bangalore;
        case 80 :
            return CityConfig.nashik;
        default:
          return CityConfig.bangalore;
      }
    } else {
      if (id <= 0) {
        return CityConfig.bangalore;
      }
      switch (id) {
        case 1 :
            return CityConfig.mumbai;
        case 2 :
            return CityConfig.delhi_NCR;
        case 6 :
            return CityConfig.ahmedabad;
        case 3 :
        case 4 :
        case 5 :
        case 7 :
        case 8 :
        case 9 :
            return CityConfig.bangalore;
        case 10 :
            return CityConfig.hyderabad;
        case 11 :
            return CityConfig.chennai;
        case 12 :
            return CityConfig.coimbatore;
        case 13 :
            return CityConfig.indore;
        case 14 :
            return CityConfig.nagpur;
        case 15 :
            return CityConfig.chandigarh;
        case 16 :
            return CityConfig.vadodara;
        case 17 :
            return CityConfig.ludhiana;
        case 18 :
            return CityConfig.kochi;
        case 19 :
            return CityConfig.jaipur;
        case 20 :
            return CityConfig.pune;
        
      }
    }
  } else {
    switch (id) {
      case 1 :
          return CityConfig.mumbai;
      case 2 :
          return CityConfig.delhi_NCR;
      case 3 :
          return CityConfig.bangalore;
      case 4 :
          return CityConfig.hyderabad;
      case 5 :
          return CityConfig.chennai;
      case 6 :
          return CityConfig.ahmedabad;
      case 7 :
          return CityConfig.jaipur;
      case 8 :
          return CityConfig.pune;
      case 9 :
          return CityConfig.kolkata;
      case 10 :
          return CityConfig.surat;
      case 11 :
          return CityConfig.lucknow;
      case 12 :
          return CityConfig.coimbatore;
      case 13 :
          return CityConfig.indore;
      case 14 :
          return CityConfig.nagpur;
      case 15 :
          return CityConfig.chandigarh;
      case 16 :
          return CityConfig.vadodara;
      case 17 :
          return CityConfig.ludhiana;
      case 18 :
          return CityConfig.kochi;
      case 19 :
          return CityConfig.nashik;
      default:
        return CityConfig.bangalore;
    }
  }
}

function cityToGeoRegionId(city) {
  if (Config.Env.env === "staging") {
    var value = $$String.lowercase_ascii(city);
    if (value === CityConfig.mumbai) {
      return 1;
    } else if (value === CityConfig.delhi_NCR || value === CityConfig.delhi) {
      return 2;
    } else if (value === CityConfig.bangalore) {
      return 3;
    } else if (value === CityConfig.hyderabad) {
      return 10;
    } else if (value === CityConfig.chennai) {
      return 11;
    } else if (value === CityConfig.ahmedabad) {
      return 6;
    } else if (value === CityConfig.jaipur) {
      return 19;
    } else if (value === CityConfig.pune) {
      return 20;
    } else if (value === CityConfig.kolkata) {
      return 71;
    } else if (value === CityConfig.surat) {
      return 72;
    } else if (value === CityConfig.lucknow) {
      return 73;
    } else if (value === CityConfig.coimbatore) {
      return 12;
    } else if (value === CityConfig.indore) {
      return 13;
    } else if (value === CityConfig.nagpur) {
      return 14;
    } else if (value === CityConfig.chandigarh) {
      return 15;
    } else if (value === CityConfig.vadodara) {
      return 16;
    } else if (value === CityConfig.ludhiana) {
      return 17;
    } else if (value === CityConfig.kochi) {
      return 18;
    } else if (value === CityConfig.nashik) {
      return 80;
    } else {
      return 3;
    }
  }
  var value$1 = $$String.lowercase_ascii(city);
  if (value$1 === CityConfig.mumbai) {
    return 1;
  } else if (value$1 === CityConfig.delhi_NCR || value$1 === CityConfig.delhi) {
    return 2;
  } else if (value$1 === CityConfig.bangalore) {
    return 3;
  } else if (value$1 === CityConfig.hyderabad) {
    return 4;
  } else if (value$1 === CityConfig.chennai) {
    return 5;
  } else if (value$1 === CityConfig.ahmedabad) {
    return 6;
  } else if (value$1 === CityConfig.jaipur) {
    return 7;
  } else if (value$1 === CityConfig.pune) {
    return 8;
  } else if (value$1 === CityConfig.kolkata) {
    return 9;
  } else if (value$1 === CityConfig.surat) {
    return 10;
  } else if (value$1 === CityConfig.lucknow) {
    return 11;
  } else if (value$1 === CityConfig.coimbatore) {
    return 12;
  } else if (value$1 === CityConfig.indore) {
    return 13;
  } else if (value$1 === CityConfig.nagpur) {
    return 14;
  } else if (value$1 === CityConfig.chandigarh) {
    return 15;
  } else if (value$1 === CityConfig.vadodara) {
    return 16;
  } else if (value$1 === CityConfig.ludhiana) {
    return 17;
  } else if (value$1 === CityConfig.kochi) {
    return 18;
  } else if (value$1 === CityConfig.nashik) {
    return 19;
  } else {
    return 3;
  }
}

function cityToStdCode(city) {
  var value = $$String.lowercase_ascii(city);
  if (value === CityConfig.mumbai) {
    return "022";
  } else if (value === CityConfig.delhi_NCR || value === CityConfig.delhi) {
    return "011";
  } else if (value === CityConfig.bangalore) {
    return "080";
  } else if (value === CityConfig.hyderabad) {
    return "040";
  } else if (value === CityConfig.chennai) {
    return "044";
  } else if (value === CityConfig.ahmedabad) {
    return "079";
  } else if (value === CityConfig.jaipur) {
    return "0141";
  } else if (value === CityConfig.pune) {
    return "020";
  } else if (value === CityConfig.kolkata) {
    return "033";
  } else if (value === CityConfig.surat) {
    return "0261";
  } else if (value === CityConfig.lucknow) {
    return "0522";
  } else if (value === CityConfig.coimbatore) {
    return "0422";
  } else if (value === CityConfig.indore) {
    return "0731";
  } else if (value === CityConfig.nagpur) {
    return "0712";
  } else if (value === CityConfig.chandigarh) {
    return "0172";
  } else if (value === CityConfig.vadodara) {
    return "0265";
  } else if (value === CityConfig.ludhiana) {
    return "0161";
  } else if (value === CityConfig.kochi) {
    return "0484";
  } else if (value === CityConfig.nashik) {
    return "0253";
  } else {
    return "080";
  }
}

function toDisplayCity(city) {
  if (city === CityConfig.delhi) {
    return CityConfig.delhi_NCR;
  } else {
    return city;
  }
}

export {
  geoRegionIdToCity ,
  cityToGeoRegionId ,
  cityToStdCode ,
  toDisplayCity ,
  
}
/* Config Not a pure module */
